export default {
  list: [
    {
      title: 'منتظر',
      value: 'PENDING'
    },
    {
      title: 'فعال',
      value: 'ACTIVATED'
    },
    {
      title: 'مسدود',
      value: 'BANNED'
    }
  ],
  values: {
    PENDING: 'PENDING',
    ACTIVATED: 'ACTIVATED',
    BANNED: 'BANNED '
  }
};
